import React from 'react';

import {FormSection} from '@pb/kit-component-form-section';

import {PresetSuggest} from './preset-suggest';

import type {PresetRelationItem} from 'src/openapi/admin/models/PresetRelationItem';

type Props = {
    relations: PresetRelationItem[],
    onAddRelations: (relations: PresetRelationItem[]) => void,
};

export const PresetSuggestSection = (props: Props) => {
    const {onAddRelations, relations} = props;

    return (
        <FormSection headline="Roles, Grants, and Resource(s) in this Preset">
            <PresetSuggest
                selectedRelations={relations}
                onSearch={onAddRelations}
            />
        </FormSection>
    );
};
